import styled from 'styled-components';
import {
  BLACK_COLOR,
  DEFAULT_FONT,
  BASIC_COLOR,
  DARK_RED,
  WHITE_COLOR,
  SECONDARY_COLOR,
  DARK_COLOR,
  LIGHT_COLOR,
  TABLE_HEADER
} from '../../styles/variables';

export const BatchDetailsContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 640px;
  font-family: ${DEFAULT_FONT};
  a {
    text-underline-position: under;
  }
  svg {
    margin-right: 6px;
  }
  .reprintContainer {
    width: 40%;
    position: absolute;
    right: 0;
    margin: 15px 60px 0 0;
    text-align: right;
    display: flex;
    align-items: center;
    column-gap: 12px;
    justify-content: flex-end;
    .count {
      font-size: 12px;
      font-weight: 600;
      color: ${BLACK_COLOR};
      margin: 5px;
    }
    .ant-btn {
      margin-left: 12px;
      height: 38px;
      width: 148px;
      font-family: ${DEFAULT_FONT} !important;
      border-color: ${BASIC_COLOR};
      background: ${BASIC_COLOR};
      color: ${BLACK_COLOR};
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      border-radius: 25px;
    }
    div {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    a {
      display: flex;
      align-items: center;
    }
  }
  .ant-table-thead > tr > th .ant-table-header-column .ant-checkbox {
    display: ${props => props.isInQueue && 'none'};
  }
  .ant-checkbox-disabled {
    display: none;
  }
  .ant-table-wrapper {
    padding-left: ${props =>
      props.filterSection
        ? '320px !important'
        : !props.isModalType0
        ? '70px !important'
        : '25px !important'};
    transition: padding-left 600ms ease;
  }
  .ant-table-wrapper .ant-table-tbody > tr > td .anticon-question-circle {
    color: ${DARK_RED};
    transform: scale(1.2);
  }
  .ant-modal-content {
    border-radius: 12px !important;
  }
  .ant-table-wrapper .ant-table-tbody > tr > td {
    padding: 12px 12px !important;
    max-width: 240px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .title {
    position: absolute;
    top: 20px;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 1px;
  }
  .text-center {
    text-align: center;
    left: auto;
  }
  .ant-table-wrapper {
    width: 100% !important;
    padding: ${({ printFailures }) =>
      printFailures ? '65px 25px 25px 50px' : '65px 25px 15px 50px'};
    background: ${WHITE_COLOR};
    .anticon svg {
      cursor: pointer;
      font-size: 15px;
    }

    .ant-spin-nested-loading {
      height: 100%;
    }

    .ant-spin-container {
      height: 100%;
    }
    .ant-table {
      height: 95% !important;
      .ant-table-tbody > tr > td {
        padding: ${props =>
          props.printFailures ? '16px 12px !important' : '13px 12px !important'};
        background: none;
      }
      a {
        color: #333;
        text-underline-position: under;
      }
    }
    .ant-table-body {
      overflow-x: scroll;
      ::-webkit-scrollbar {
        height: 5px;
      }

      ::-webkit-scrollbar-thumb {
        background-color: ${SECONDARY_COLOR};
        border-radius: 25px;
      }
    }

    .ant-table-layout-fixed table {
      table-layout: auto;
    }

    .ant-table-pagination.ant-pagination {
      margin: 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      position: relative;
    }

    .ant-table-thead > tr > th {
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.5px;
      background: ${SECONDARY_COLOR};
      color: #fff;
      .ant-checkbox-inner {
        background: ${SECONDARY_COLOR};
      }
    }
    .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner {
      color: #f2f2f2;
    }

    .ant-table-thead
      > tr
      > th
      .ant-table-column-sorter
      .ant-table-column-sorter-inner
      .ant-table-column-sorter-up.on {
      color: ${DARK_COLOR};
    }
    .ant-table-thead
      > tr
      > th
      .ant-table-column-sorter
      .ant-table-column-sorter-inner
      .ant-table-column-sorter-down.on {
      color: ${DARK_COLOR};
    }
    .ant-table-thead > tr > th .anticon-filter {
      color: #f2f2f2;
    }
    .ant-table-filter-dropdown {
      font-family: ${DEFAULT_FONT} !important;
    }
    .ant-table-thead > tr > th .ant-table-filter-selected.anticon {
      color: ${DARK_COLOR} !important;
    }

    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-filters:hover
      .anticon-filter:hover,
    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-filters:hover
      .ant-table-filter-icon:hover {
      color: #f2f2f2 !important;
      background: ${LIGHT_COLOR} !important;
    }

    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-filters
      .anticon-filter.ant-table-filter-open,
    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-filters
      .ant-table-filter-icon.ant-table-filter-open {
      color: #f2f2f2 !important;
      background: ${LIGHT_COLOR} !important;
    }

    .ant-table-thead
      > tr
      > th
      .ant-table-header-column
      .ant-table-column-sorters:hover
      ~ .ant-table-thead
      > tr
      > th
      .ant-table-header-column
      .ant-table-column-sorters:hover:before {
      background-color: ${LIGHT_COLOR} !important;
    }

    .ant-table-tbody > tr > td {
      color: #4c4b4e;
      font-size: 13px;
      letter-spacing: 0.5px;
      font-weight: 600;
      padding: 13px 16px !important;
    }
    .ant-table-tbody > tr:nth-child(even) {
      background: #f7fbe9;
    }

    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
      background: #f7f7f7;
    }
    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-filters:hover
      .ant-table-filter-icon:hover {
      background: ${LIGHT_COLOR} !important;
    }
    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-filters
      .ant-table-filter-icon.ant-table-filter-open {
      background: ${LIGHT_COLOR} !important;
    }

    ////////////   table-pagination /////////

    .ant-pagination-prev {
      position: absolute;
      left: 0;
    }

    .ant-pagination-next {
      position: absolute;
      right: 0;
    }

    .ant-table-pagination.ant-pagination {
      float: none;
      margin: 16px 0;
      text-align: center;
    }
    .ant-pagination-item a {
      text-decoration: none;
      transition: none;
    }
    .ant-pagination-item:focus a,
    .ant-pagination-item:hover a {
      color: ${TABLE_HEADER};
    }
    .ant-pagination-item:focus,
    .ant-pagination-item:hover {
      border-color: ${TABLE_HEADER};
    }
    .ant-pagination-item-active,
    .ant-pagination-item-active:hover,
    .ant-pagination-item-active:focus {
      font-weight: 500;
      background: ${TABLE_HEADER};
      border-color: ${TABLE_HEADER};
    }
    .ant-pagination-item-active a,
    .ant-pagination-item-active:focus a,
    .ant-pagination-item-active:hover a {
      color: ${WHITE_COLOR};
    }
    .ant-pagination-prev:focus .ant-pagination-item-link,
    .ant-pagination-next:focus .ant-pagination-item-link,
    .ant-pagination-prev:hover .ant-pagination-item-link,
    .ant-pagination-next:hover .ant-pagination-item-link {
      color: ${TABLE_HEADER};
      border-color: ${TABLE_HEADER};
    }
    .ant-pagination-disabled a,
    .ant-pagination-disabled:hover a,
    .ant-pagination-disabled:focus a,
    .ant-pagination-disabled,
    .ant-pagination-disabled:hover,
    .ant-pagination-disabled:focus {
      display: none;
    }
  }
  .ant-collapse-borderless > .ant-collapse-item {
    margin: 0 !important;
  }
  .ant-collapse {
    height: 200px;
    margin-top: 15px;
    overflow: hidden;
    overflow-y: auto;
    border-radius: 0;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
